import { useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { ChoixListe } from "@/pages/parametres/ChoixListe";

const AUCUN = "__aucun__";

export const Correspondances = ({ e, onEnregistre }) => {
  const [etapes, setEtapes] = useState(e.etapes);
  const [users, setUsers] = useState(e.utilisateurs);
  const [envoi, setEnvoi] = useState(false);
  const optionsEtapes = e.processus.flatMap((p) => p.etapes.map((s) => ({ code: `${p.id}::${s.code}`, label: `${p.nom} › ${s.nom}` })));
  const optionsUsers = [{ code: AUCUN, label: "Personne (fiche non attribuée)" }, ...e.utilisateurs_crm.map((u) => ({ code: u.id, label: u.nom }))];
  const enregistrer = async () => {
    setEnvoi(true);
    try { const r = await api.put("/migration-nocrm/correspondances", { etapes, utilisateurs: users }); onEnregistre(r.data); toast.success("Correspondances enregistrées."); }
    catch (x) { toast.error(messageErreur(x)); }
    finally { setEnvoi(false); }
  };
  return (
    <div className="space-y-4">
      <p className="at-label">Étapes noCRM → étapes du CRM</p>
      {e.etapes_nocrm.map((n, i) => (
        <div key={n} className="space-y-1" data-testid={`migration-stage-row-${i}`}>
          <p className="text-sm font-semibold">{n} <span className="at-muted font-normal">· {e.source.par_etape[n]} fiche(s)</span></p>
          <ChoixListe valeur={etapes[n] ? `${etapes[n].processus_id}::${etapes[n].etape}` : ""} options={optionsEtapes} testId={`migration-stage-select-${i}`}
            placeholder="À associer (obligatoire)" onChange={(v) => { const [processus_id, etape] = v.split("::"); setEtapes({ ...etapes, [n]: { processus_id, etape } }); }} />
        </div>
      ))}
      <p className="at-label pt-2">Utilisateurs noCRM → utilisateurs du CRM</p>
      {e.utilisateurs_nocrm.map((u, i) => (
        <div key={u.email} className="space-y-1" data-testid={`migration-user-row-${i}`}>
          <p className="text-sm font-semibold break-words">{u.nom} <span className="at-muted font-normal">· {e.source.par_utilisateur[u.email]} fiche(s)</span></p>
          <ChoixListe valeur={users[u.email] || AUCUN} options={optionsUsers} testId={`migration-user-select-${i}`}
            onChange={(v) => setUsers({ ...users, [u.email]: v === AUCUN ? null : v })} />
        </div>
      ))}
      <button type="button" onClick={enregistrer} disabled={envoi} className="at-btn at-btn-primary w-full" data-testid="migration-save-mapping"><Save size={16} />Enregistrer les correspondances</button>
    </div>
  );
};
